<script setup lang="ts">
import { IonModal, IonToast } from '@ionic/vue'
import { onMounted, ref, watch } from 'vue'
import { Clipboard } from '@capacitor/clipboard'
import { Share } from '@capacitor/share'
import type { CanShareResult } from '@capacitor/share'
import { useDebugStore } from '@/store/debug'

const debugStore = useDebugStore()

const isOpen = ref(false)
const canShare = ref(false)
const toastIsOpen = ref(false)
const links = 'https://stage-api.sekai.chat/debug/request?requestId='

watch(() => debugStore.isDebug, (newState) => {
  if (newState) {
    toastIsOpen.value = true
  }
})

onMounted(async () => {
  const res: CanShareResult = await Share.canShare()
  if (res.value) {
    canShare.value = true
  }
})

function closeModal() {
  isOpen.value = false
}

async function writeToClipboard(text: string) {
  await Clipboard.write({
    string: text,
  })
}

async function share(url: string) {
  console.log(111)

  await Share.share({
    url: links + url,
  })
}

function handleCloseDebug() {
  debugStore.count = 0
  debugStore.lastTime = 0
  closeModal()
}
</script>

<template>
  <div>
    <div v-if="debugStore.isDebug" class="fixed z-9 right-0 pt-unsafe-area top-0">
      <button class="flex items-center gap-1 px-2 py-1.5 rounded-full bg-secondary active:op-80" @click="isOpen = true">
        <p class="text-on-bg-1 text-3 fw-400 leading-3.5">
          {{ $t('debugModal.title') }}
        </p>
      </button>
    </div>
    <ion-toast
      :is-open="toastIsOpen"
      :message="$t('debugModal.successTips')"
      :duration="3000"
      position="middle"
      class="custom-toast"
      @did-dismiss="() => toastIsOpen = false"
    />
    <ion-modal
      id="custom-ion-modal"
      :is-open="isOpen"
      :backdrop-dismiss="true"
      trigger="custom-ion-modal"
      @did-dismiss="closeModal"
    >
      <p class="p-3 text-on-bg-1 fw-400 text-center">
        {{ $t('debugModal.title') }}
      </p>
      <div class="flex-1 overflow-y-auto w-full pt-6 pb-4 px-4 flex flex-col items-center bg-[#1f1f1f]">
        <div v-for="(item, index) in debugStore.requestIds" :key="index" class="w-full">
          <p>{{ item.time }}</p>
          <div class="flex w-full justify-between items-center gap-3">
            <a
              :href="links + item.requestId" target="_blank"
              class="flex-1"
            >
              <p>
                {{ item.requestId }}
              </p>
            </a>
            <div class="flex gap-3">
              <button class="flex items-center gap-1 px-3 py-1.5 rounded-full bg-secondary active:op-80" @click="writeToClipboard(item.requestId)">
                <p class="text-on-bg-1 text-3 fw-400 leading-3.5">
                  {{ $t('debugModal.copy') }}
                </p>
              </button>
              <button v-if="canShare" class="flex items-center gap-1 px-3 py-1.5 rounded-full bg-secondary active:op-80" @click="share(item.requestId)">
                <p class="text-on-bg-1 text-3 fw-400 leading-3.5">
                  {{ $t('debugModal.share') }}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <button class="flex items-center justify-center my-3 px-3 py-1.5 rounded-full bg-secondary active:op-80" @click="handleCloseDebug">
          <p class="text-on-bg-1 text-3 fw-400 leading-3.5">
            {{ $t('debugModal.close') }}
          </p>
        </button>
      </div>
    </ion-modal>
  </div>
</template>

<style scoped>
ion-modal#custom-ion-modal {
  --overflow-y: auto;
  --border-radius: 16px;
  --width: 90vw;
  --height: 60vh;
  --border-radius: 6px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
  --background: #1f1f1f;
}

ion-toast.custom-toast{
  --background: var(--ion-background-color);
  --spinner-color: var(--ion-text-secondary-color);
  color: var(--ion-text-secondary-color);
}
</style>
@/store/debug
